import EmployeeModel from "./EmployeeModel";
import OrderJobModel from "./OrderJobModel";
import OrderModel from "./OrderModel";

export default class EmployeeJobScheduleModel {
	constructor(data?: any) {
		if (data) {
			this.orderJobAssigneeId = data.orderJobAssigneeId ?? 0;
			this.scheduledDate = data.scheduledDate ?? '1987-01-01';
			this.scheduledStartTime = data.scheduledStartTime ?? '00:00:00';
			this.scheduledEndTime = data.scheduledEndTime ?? '00:00:00';
			this.scheduledEndDate = data.scheduledEndDate ?? '1987-01-01';
			this.allocationPercent = data.allocationPercent ?? 0;
			this.virtual = data.virtual ?? false;
			this.subcontract = data.subcontract ?? false;
			this.isDisabled = data.isDisabled === true;
			
			if (data.employee?.id) {
				this.employee = new EmployeeModel(data.employee);
			}

			if (data.order?.id) {
				this.order = new OrderModel(data.order);
			}

			if (data.job?.id) {
				this.job = new OrderJobModel(data.job);
			}
		}
	}

	orderJobAssigneeId = 0;
	scheduledDate: string = '';
	scheduledStartTime: string = '';
	scheduledEndTime: string = '';
	scheduledEndDate: string = '';
	employee: EmployeeModel | null = null;
	order: OrderModel | null = null;
	job: OrderJobModel | null = null;
	allocationPercent = 0;
	virtual = false;
	subcontract = false;
	isDisabled = false;
}
